import React from 'react';
import { Loader2, Ruler, ShieldCheck } from 'lucide-react';
import ResumenSelecciones, { armarResumen } from './ResumenSelecciones';
import OpcionesEnvio from './OpcionesEnvio';
import MedidasCoordinacion from './MedidasCoordinacion';
import { ResumenComprador } from './PasoDatosInvitado';
import { cop } from './tiendaUtils';

const Fila = ({ label, valor, fuerte, testId }) => (
  <div className={`flex justify-between gap-3 ${fuerte ? 'border-t border-zinc-800 pt-3 text-lg font-semibold text-white' : 'text-sm text-zinc-400'}`}>
    <span>{label}</span><span className={fuerte ? 'text-[#C9A962]' : ''} data-testid={testId}>{valor}</span>
  </div>
);

const FilaPuntos = ({ info, puntos, descuento, onEditar }) => (
  <div className="flex items-center justify-between gap-3 text-sm text-zinc-400">
    <span>Puntos JPM{info ? ` (${puntos.toLocaleString('es-CO')})` : ''}</span>
    {info ? (
      <span className="flex items-center gap-2">
        <span data-testid="revisar-descuento">-{cop(descuento)} COP</span>
        <button type="button" onClick={onEditar} className="text-xs text-[#C9A962] hover:underline" data-testid="revisar-editar-puntos">Cambiar</button>
      </span>
    ) : (
      <a href="/mi-jpm" className="text-right text-xs text-[#C9A962] hover:underline" data-testid="revisar-puntos-login">Inicia sesión en Mi JPM para usarlos</a>
    )}
  </div>
);

export default function PasoRevisar({ datos, grupos, sel, puntos, envio, setEnvio, medidasModo, setMedidasModo, comprador, onEditar, enviando, onConfirmar }) {
  const { producto, puntos: info, envio_opciones: opciones, medidas } = datos;
  const descuento = info ? puntos * info.valor_por_punto : 0;
  const total = producto.precio - descuento;
  const pasoExtra = grupos.length;

  return (
    <div className="space-y-4" data-testid="paso-revisar">
      <div className="rounded-2xl border border-[#27272A] bg-[#18181B] px-5 py-2">
        <ResumenSelecciones selecciones={armarResumen(grupos, sel)} onEditar={onEditar} />
      </div>
      {comprador && <ResumenComprador comprador={comprador} onEditar={() => onEditar(pasoExtra)} />}
      {medidas.registradas ? (
        <div className="flex gap-3 rounded-2xl border border-[#27272A] bg-[#18181B] p-4" data-testid="medidas-aviso">
          <Ruler className="mt-0.5 h-5 w-5 shrink-0 text-[#C9A962]" />
          <p className="text-sm text-zinc-300">{medidas.mensaje}</p>
        </div>
      ) : <MedidasCoordinacion valor={medidasModo} onCambiar={setMedidasModo} />}
      <div className="rounded-2xl border border-[#27272A] bg-[#18181B] p-5">
        <OpcionesEnvio opciones={opciones} envio={envio} setEnvio={setEnvio} />
      </div>
      <div className="space-y-2 rounded-2xl border border-[#27272A] bg-[#18181B] p-5" data-testid="revisar-totales">
        <Fila label={`${producto.nombre} (${producto.precio_nota})`} valor={`${cop(producto.precio)} COP`} />
        <FilaPuntos info={info} puntos={puntos} descuento={descuento} onEditar={() => onEditar(pasoExtra)} />
        <Fila label="Envío" valor="Se paga aparte" />
        <Fila label="Total a pagar" valor={`${cop(total)} COP`} fuerte testId="revisar-total" />
      </div>
      <button onClick={onConfirmar} disabled={enviando} className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#C9A962] py-4 font-semibold text-black transition-colors hover:bg-[#D4B872] disabled:opacity-60" data-testid="tienda-confirmar">
        {enviando ? <Loader2 className="h-5 w-5 animate-spin" /> : <ShieldCheck className="h-5 w-5" />}
        {total > 0 ? 'Confirmar pedido e ir a pagar' : 'Confirmar pedido'}
      </button>
      <p className="text-center text-xs text-zinc-500">
        Al confirmar, guardamos tu pedido{puntos > 0 ? ' y descontamos los puntos usados' : ''}.{total > 0 ? ' Luego verás el enlace de pago de Bold.' : ''}
      </p>
    </div>
  );
}
